import { Route } from '@/app/router'
import GuestMiddleware from '@middleware/Guest'
import AuthenticatedMiddleware from '@middleware/Authenticated'
import SessionKeyMiddleware from '@middleware/SessionKey'

// import Auth from '@views/Auth/AuthView'
// There was a bug when lazyloading AuthView - middleware wasn't working. Since then i changed middleware functionality, but there is a chance middleware could fail.
const Auth = () => import('@views/Auth/AuthView')
const AuthLogin = () => import('@views/Auth/AuthLogin')
const AuthForgotPassword = () => import('@views/Auth/AuthForgotPassword')
const AuthResetPassword = () => import('@views/Auth/AuthResetPassword')
const AuthLogout = () => import('@views/Auth/AuthLogout')
const AuthPasswordChallenge = () => import('@views/Auth/AuthPasswordChallenge')
const AuthMfaChallenge = () => import('@views/Auth/AuthMfaChallenge')
const AuthMfaSetup = () => import('@views/Auth/AuthMfaSetup')

export default [
	new Route('/auth', Auth).children([
		new Route('/').redirect({ name: 'Auth:Login' }),
		new Route('login', AuthLogin).as('Auth:Login').middlewares([GuestMiddleware]),
		new Route('forgot', AuthForgotPassword)
			.as('Auth:ForgotPassword')
			.middlewares([GuestMiddleware]),
		new Route('reset', AuthResetPassword)
			.as('Auth:ResetPassword')
			.middlewares([GuestMiddleware]),
		new Route('logout', AuthLogout)
			.as('Auth:Logout')
			.middlewares([AuthenticatedMiddleware])
			.meta({ skipInspect: true }),
		new Route('challange/password', AuthPasswordChallenge)
			.as('Auth:PasswordChallenge')
			.middlewares([SessionKeyMiddleware]),
		// The Cognito challenge session lives in Vuex state, never in the URL
		// (URLs are captured by Sentry/LogRocket and browser history).
		new Route('mfa/challenge', AuthMfaChallenge)
			.as('Auth:MfaChallenge')
			.middlewares([SessionKeyMiddleware]),
		new Route('mfa/setup', AuthMfaSetup)
			.as('Auth:MfaSetup')
			.middlewares([AuthenticatedMiddleware])
	])
]
